import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ComponentRef,
  DestroyRef,
  ElementRef,
  HostBinding,
  inject,
  OnInit,
  Type,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { OverlayService } from '@core/services/overlay/overlay.service';
import { take } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'hd-overlay',
  standalone: true,
  imports: [],
  templateUrl: './overlay.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: 'overlay.component.scss',
})
export class OverlayComponent implements OnInit {
  private elRef = inject(ElementRef);
  private cd = inject(ChangeDetectorRef);
  private overlayService = inject(OverlayService);
  private destroyer = inject(DestroyRef);

  @ViewChild('ref', { read: ViewContainerRef, static: true })
  ref?: ViewContainerRef;

  @HostBinding('class.visible') get visible(): boolean | undefined {
    return this.ref && this.ref.length > 0;
  }

  // TODO: For now commenting out closing the dialog with click on overlay, to not loose accidentally already inputed data
  // @HostListener('mousedown', ['$event'])
  // mouseDown(event: MouseEvent) {
  //   if (!this.elRef?.nativeElement.firstChild.contains(event.target)) {
  //     this.ref?.clear();
  //   }
  // }

  ngOnInit() {
    this.overlayService.overlayRequest$
      .pipe(takeUntilDestroyed(this.destroyer))
      .subscribe((request) => {
        const componentRef = this.createComponent(request.component);

        componentRef.instance.componentDestroyed.pipe(take(1)).subscribe(() => {
          if (request.afterDestroy) {
            request.afterDestroy();
          }
        });

        request.afterCreate(componentRef);
      });

    this.overlayService.markForCheck$
      .pipe(takeUntilDestroyed(this.destroyer))
      .subscribe(() => this.cd.markForCheck());
  }

  private createComponent<T>(component: Type<T>): ComponentRef<T> {
    this.ref?.clear();
    const componentRef = this.ref!.createComponent(component);
    this.cd.markForCheck();
    return componentRef;
  }
}
